<template>
  <div class="switch-container">
    <div class="switch-label" :class="{ active: !value }">{{$t('message.misc.inMinutes')}}</div>
    <div class="onoffswitch">
      <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="myonoffswitch" tabindex="0" :value="value" v-model="switchVal" />
      <label class="onoffswitch-label" for="myonoffswitch">
        <span class="onoffswitch-inner"></span>
        <span class="onoffswitch-switch"></span>
      </label>
    </div>
    <div class="switch-label" :class="{ active: value }">{{$t('message.misc.inSeconds')}}</div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    switchVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped>
.switch-label {
  margin: 0 1em;
  color: #999;
  transition: 0.3s;
}

.switch-container {
  display: flex;
  flex-direction: row;
  align-content: space-around;
  align-items: center;
  margin-top: 20px;
}

.active {
  color: #3fa9f5;
}

.onoffswitch {
  position: relative;
  width: 80px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.onoffswitch-checkbox {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.onoffswitch-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #ffffff;
  border-radius: 50px;
}
.onoffswitch-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.1s ease-in 0s;
}
.onoffswitch-inner:before,
.onoffswitch-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 24px;
  padding: 0;
  line-height: 24px;
  font-size: 18px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  box-sizing: border-box;
}
.onoffswitch-inner:before {
  content: "";
  padding-left: 12px;
  background-color: #101114;
  color: #ffffff;
}
.onoffswitch-inner:after {
  content: "";
  padding-right: 12px;
  background-color: #101114;
  color: #999999;
  text-align: right;
}
.onoffswitch-switch {
  display: block;
  width: 35px;
  margin: -3.5px;
  background: #3fa9f5;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 52px;
  border: 2px solid #ffffff;
  border-radius: 50px;
  transition: all 0.1s ease-in 0s;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
  margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
  right: 0px;
}
</style>
